import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import Portal from '../Portal';
import ActionSheetCloseButton from './ActionSheetCloseButton';
import ActionSheetContext from './ActionSheetContext';

const Menu = ({ className, closeButtonLabel, children }) => {
  const { isVisible, setIsVisible, triggerRef } = React.useContext(ActionSheetContext);

  const toggleIsVisible = e => {
    if (!e.defaultPrevented || e.button === 0) {
      setIsVisible(!isVisible);
      e.preventDefault();
    }
  };

  const onClickOutside = e => {
    e.stopPropagation();
    setIsVisible(false);
  };

  React.useEffect(() => {
    if (triggerRef && triggerRef.current) {
      triggerRef.current.addEventListener('click', toggleIsVisible);
      return () => {
        if (triggerRef.current) {
          triggerRef.current.removeEventListener('click', toggleIsVisible);
        }
      };
    }
    return () => {};
  }, [triggerRef, isVisible]);

  const cn = useClassNames(
    () => [
      'fixed',
      'top-0',
      'left-0',
      'bottom-0',
      'right-0',
      isVisible ? 'flex' : 'hidden',
      'justify-center',
      'items-end',
      'text-lg',
      'z-actionsheet-menu',
      className,
    ],
    [className, isVisible],
  );

  return (
    <Portal>
      <div
        data-component="ActionSheetBackdrop"
        className="fixed inset-0 bg-slate-500 opacity-50 z-actionsheet-backdrop"
        hidden={!isVisible}
      />
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={cn} onClick={onClickOutside}>
        <div data-component="ActionSheetMenu" className="inline-flex flex-col mx-auto min-w-64">
          <ul className="shadow-lg rounded-lg overflow-hidden mb-4">{children}</ul>
          <ActionSheetCloseButton>{closeButtonLabel}</ActionSheetCloseButton>
        </div>
      </div>
    </Portal>
  );
};

Menu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  closeButtonLabel: PropTypes.string.isRequired,
};

export default Menu;
